/**
 * 报表管理
 */
import http from "@/request/http";
export default {
  /******   工单管理   *****/
  // 工单管理列表
  logisticsOrderList: (params) =>
    http.get(`/api/odoo/workOrder/findWorkOrderList`, params),
  // 创建工单
  logisticsCreateWorkOrder: (params) =>
    http.post(`/api/odoo/workOrder/saveWorkOrder`, params),
  // 获取处理记录
  logisticsOrderRecordList: (params) =>
    http.get(`/api/odoo/workOrder/getRecordList`, params),
  // 获取项目部门
  getProjectDepartment: (params) =>
    http.get(`/api/odoo/inspectionPlan/plan/findDepartments`, params),
  // 操作工单流程
  logisticsOrderOperation: (params) =>
    http.post(`/api/odoo/workOrder/updateWorkOrder`, params),
  // 获取工单全部来源
  logisticsOrderGetSource: (params) =>
    http.get(`/api/odoo/workOrder/getWorkOrderTypes`, params),
  // 获取工单评价
  logisticsOrderComment: (params) =>
    http.get(`/api/odoo/workOrder/getComment`, params),

  /******   工单分析   *****/
  logisticsWOANALOverview: (params) =>
    http.get(`/api/odoo/workOrder/getOverview`, params),
  logisticsWOANALSystem: (params) =>
    http.get(`/api/odoo/workOrder/getSubsystemAnalysis`, params),
  logisticsWOANALStatus: (params) =>
    http.get(`/api/odoo/workOrder/getStatusAnalysis`, params),
  logisticsWOANALSource: (params) =>
    http.get(`/api/odoo/workOrder/getSourceAnalysis`, params),
  logisticsWOANALHourNum: (params) =>
    http.get(`/api/odoo/workOrder/getTwentyFourHourTrend`, params),
  logisticsWOANALTrend: (params) =>
    http.get(`/api/odoo/workOrder/getTrendCharts`, params),
  logisticsWOANALTable: (params) =>
    http.get(`/api/odoo/workOrder/getAnalysisDetailsPage`, params),

  /******   保养管理   *****/
  // 保养记录
  maintainGetrecord: (params) =>
    http.get(`/api/odoo/maintenance/record/getRecordPage`, params),
  // 保养计划
  maintainGetPlanList: (params) =>
    http.get(`/api/odoo/maintenance/plan/getPlans`, params),
  // 新增/修改保养计划
  maintainAddEditPlan: (params) =>
    http.post(`/api/odoo/maintenance/plan/save`, params),
  // 获取保养计划历史数据
  maintainGetPlanHistory: (params) =>
    http.get(`/api/odoo/maintenance/plan/getPlanByDeviceId`, params),
  // 获取可修改保养计划
  maintainEditPlanList: (params) =>
    http.get(
      `/api/odoo/maintenance/plan/getUnmaintainedPlanByDeviceId`,
      params
    ),
  // 删除计划
  maintainDeletePlanList: (params, deviceId) =>
    http.delete(
      `/api/odoo/maintenance/plan/deleteByDeviceId/${deviceId}`,
      params
    ),

  /******   巡检管理   *****/
  // 巡检点 获取列表
  patrolPointPageList: (params) =>
    http.get(`/api/odoo/inspectionPoint/point/getPoints`, params),
  // 巡检点 修改操作巡检点
  patrolPointOperation: (params) =>
    http.post(`/api/odoo/inspectionPoint/point/update`, params),
  // 获取巡检点信息
  patrolPointGetDefaultData: (params) =>
    http.get(`/api/odoo/inspectionPoint/point/findById`, params),
  // 巡检点 删除
  patrolPointDelete: (params, id) =>
    http.delete(`/api/odoo/inspectionPoint/point/delete/${id}`, params),
  patrolPointEditQrcode: (params) =>
    http.post(`/api/odoo/inspectionPoint/point/generateQRCode`, params), //重新生成二维码

  // 巡检路线 获取列表
  patrolPouteGetList: (params) =>
    http.get(`/api/odoo/inspectionRoute/route/getRoutesPage`, params),
  // 巡检路线 回显巡检路线信息
  patrolPouteGetMsg: (params) =>
    http.get(`/api/odoo/inspectionRoute/route/findById`, params),
  // 巡检路线  新增/修改巡检路线
  patrolPouteOperation: (params) =>
    http.post(`/api/odoo/inspectionRoute/route/update`, params),
  // 巡检路线  删除巡检路线
  patrolPouteDeleteLine: (params, id) =>
    http.delete(`/api/odoo/inspectionRoute/route/delete/${id}`, params),
  // 巡检路线 编辑巡检点
  patrolGetPoutePoint: (params) =>
    http.get(`/api/odoo/inspectionRoute/route/getPointByRouteId`, params),
  // 巡检路线 添加巡检路线下巡检点
  patrolPouteAddPoint: (params) =>
    http.get(`/api/odoo/inspectionRoute/route/savePointByIdAndPointId`, params),

  // 巡检计划 获取列表
  patrolPlanGetList: (params) =>
    http.get(`/api/odoo/inspectionPlan/plan/findPlansPage`, params),
  // 获取巡检路线
  patrolPlanGetLine: (params) =>
    http.get(`/api/odoo/inspectionRoute/route/getRoutes`, params),
  // 新增/修改巡检计划
  patrolPlanEditAdd: (params) =>
    http.post(`/api/odoo/inspectionPlan/plan/save`, params),
  // 更改巡检计划状态
  patrolPlanChangeState: (params) =>
    http.post(`/api/odoo/inspectionPlan/plan/changePlanState`, params),
  // 删除巡检计划
  patrolPlanDeletePlan: (params, id) =>
    http.delete(`/api/odoo/inspectionPlan/plan/deletePlanById/${id}`, params),
  // 获取巡检计划详情
  patrolPlanGetPlanDetail: (params) =>
    http.get(`/api/odoo/inspectionTask/plan/getScheduled`, params),
  // 巡检计划详情中巡检点详情
  patrolPlanPointDelete: (params) =>
    http.get(`/api/odoo/inspectionTask/plan/pointDetails`, params),

  // 巡检记录
  patrolRecordsGetList: (params) =>
    http.get(`/api/odoo/inspectionTask/plan/getRecordPage`, params),

  /******   保养管理  *****/
  //  设备信息
  maintenanceInfoHandle: (params) =>
    http.post(`/api/odoo/inspectionPoint/point/immediateMaintenance`, params), //立即保养

  //  保养计划
  maintenancePlanGetList: (params) =>
    http.get(`/api/odoo/inspectionPlan/plan/findMaintenancePlansPage`, params), //获取列表
  maintenancePlanAddEditPlan: (params) =>
    http.post(`/api/odoo/inspectionPlan/plan/saveMaintenance`, params), //新增/修改保养计划
  maintenancePlanGetECInfo: (params) =>
    http.get(`/api/odoo/inspectionPoint/point/findByIds`, params), //获取设备保养详情

  /******   权限管理   *****/
  // 获取部门列表
  authorityGetDpartment: (params) => http.get(`/api/juji/department`, params),
  // 删除部门
  authorityDeleteDepartment: (params, id) =>
    http.delete(`/api/juji/department/${id}`, params),
  // 新增/修改部门
  authorityEditDepartment: (params) =>
    http.post(`/api/juji/department`, params),
  // 获取部门人员列表
  authorityGetUserList: (params) =>
    http.get(`/api/juji/department/users`, params),
  // 新增/编辑用户
  authorityEditUser: (params) => http.post(`/api/juji/department/user`, params),
  // 删除用户
  authorityDeleteUser: (params, id) =>
    http.delete(`/api/juji/department/user/${id}`, params),
  // 获取权限列表
  authorityGetAuthorityTree: (params) =>
    http.get(`/api/juji/sys/assignableUserMenu`, params),
  // 人员授权
  authoritySetUserAuth: (params, userId) =>
    http.put(`/api/juji/department/users/${userId}/assignUserAuth`, params),

  authorityGetOrderByUser: (params) =>
    http.get(`/api/odoo/workOrder/findUserWorkOrderRecordList`, params), //用户详情中工单记录
  authorityGetUserTolCharts: (params) =>
    http.get(
      `/api/odoo/inspectionTask/plan/getLogisticsDataStatistics`,
      params
    ), //用户详情中环形统计表

  /******   根据部门获取人员   *****/
  projectGetUserList: (params) =>
    http.get(`/api/juji/user/getUsersByDepartment`, params),

  /******   根据权限获取可分配人员列表   *****/
  projectGetUserListByPower: (params) =>
    http.get(`/api/juji/user/getUsersByPermission`, params),

  /******   根据用户ID获取所在部门ID   *****/
  projectGetDepartmentByUserId: (params) =>
    http.get(`/api/juji/department/getDepartmentByUserId`, params),

  /******   根据部门ID和用户ID获取所在用户信息   *****/
  projectGetUserInfoByUserId: (params) =>
    http.get(`/api/juji/department/getUser`, params),

  /******   根据部门获取人员   *****/
  projectGetUserListByTenant: (params) =>
    http.get(`/api/juji/user/getUsersByTenantIds`, params),
};
